// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"6613":"51dbb4204612e97c","6658":"4481b32cf0f5309c"}[chunkId] + ".js";
};